export default __webpack_public_path__ + "static/media/7.0bf9e8cb.jpeg";